import { useMutation, useQueryClient } from '@tanstack/react-query';
import { type MutationOptions, gqlFetcher } from '../fetcher';
import { DeleteParticipantDocument } from '../mutations/deleteParticipantDocument.mutation';
import type {
  DeleteParticipantDocumentMutation,
  DeleteParticipantDocumentMutationVariables,
} from '../types';

export const useDeleteParticipantDocumentMutation = (
  options?: MutationOptions<
    DeleteParticipantDocumentMutation,
    DeleteParticipantDocumentMutationVariables
  >,
) => {
  const queryClient = useQueryClient();

  return useMutation(gqlFetcher(DeleteParticipantDocument), {
    ...options,
    onSettled: async (resp, error, variables, ctx) => {
      await options?.onSettled?.(resp, error, variables, ctx);

      queryClient.invalidateQueries({
        predicate: (query) => query.queryKey.includes('participant'),
      });
    },
  });
};
